export const TEAMS_TR = {
    
}